import Image from 'app/Components/Shared/Image/image';
import React from "react";

const AbroadWithoutPackage=({icon,title,subTitle})=>{

    return (
        <div className="abroad-without-package">
          {icon &&<div className="icon">
            <Image src={icon} alt="icon" />
          </div>}
            {(title || subTitle) && <div className="titles">
                <div className="main-title">{title}</div>
                <div className="sub-title">{subTitle}</div>
            </div>}
        </div>
    )

}

export default AbroadWithoutPackage;
